import authGraphQLRequest from "utils/authGraphQLRequest";
import moment from "moment";
  
 
 export const getLogs = ({ page, per_page, searchTexts , client,start_date,end_date }: any): Promise<any> => {
    return new Promise((resolve, reject) => {

        let client_ids = client?.length > 0 ? client : ""
        let queryString = `{ 
        allRequestLogs(
            page: ${page}, 
            perPage: ${per_page}, 
            searchTexts: "${searchTexts}"
            ${client_ids ? `, clientIds: "${client_ids}"` : ""}
            ${start_date ? `, startDate: "${moment(start_date).format("YYYY-MM-DD")}"` : ""}
            ${end_date ? `, endDate: "${moment(end_date).format("YYYY-MM-DD")}"` : ""}
        ) {
            logs {
                id
                clientId
                clientName
                customerId
                customerName
                endpoint
                requestData
                responseData
                createdAt
            }
        }
        }`;
    
        authGraphQLRequest<any>(
        queryString,
        '/api/v1/graphql_request_logs'
        )
        .then((responseData) => {
            resolve(responseData);
        })
        .catch((err) => {
            reject(err);
        });
    });
 };